import classNames from "classnames";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import AscButton from "../../AscButton/AscButton";
import {
  CalendarIcon,
  DollarIcon,
  HeartFilledIcon,
  HeartIcon,
  LocationIcon,
} from "../../AscIcons";
import AscTag from "../../AscTag/AscTag";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscJobCard.module.scss";
import { convertUnderlineToSpace, formatSalaryRange } from "@ascendnow/shared";
dayjs.extend(relativeTime);

type AscJobCardJobLocationType = "remote";

export interface AscJobCardProps {
  title: string;
  datePosted: string;
  applied: boolean;
  country: string;
  jobCategory: string;
  city: string;
  jobLocationType?: AscJobCardJobLocationType;
  maxSalaryRange: number;
  minSalaryRange: number;
  toggleSave: (id: string) => void;
  onApply?: (link: string) => void;
  className: string;
  jobId: string;
  id?: number;
  isFavorite?: boolean;
  fromJobBoard?: boolean;
  isSmallVersion?: boolean;
  onButtonClick?: () => void;
}

export default function AscJobCard({
  title,
  datePosted,
  applied,
  toggleSave,
  country,
  city,
  jobCategory,
  maxSalaryRange,
  minSalaryRange,
  jobId,
  onApply,
  isFavorite = false,
  className,
  fromJobBoard = false,
  isSmallVersion = false,
  onButtonClick,
}: AscJobCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      imageClassName={styles.cardImage}
      onClick={onButtonClick}
      title={
        <div className={styles.header}>
          <div className={styles.headerText}>
            <h5 className={classNames(styles.cardTitle)}>{title}</h5>
            {applied ? <AscTag label="Applied" /> : null}
          </div>
          <div
            className={styles.iconContainer}
            onClick={(e) => {
              e.stopPropagation();
              jobId && toggleSave(jobId);
            }}
            data-testid={"asc-job-card-saved-icon-wrapper"}
          >
            {isFavorite ? (
              <HeartFilledIcon
                className={styles.savedIcon}
                data-testid={"asc-job-card-saved-icon"}
              />
            ) : (
              <HeartIcon
                className={styles.savedIcon}
                data-testid={"asc-job-card-not-saved-icon"}
              />
            )}
          </div>
        </div>
      }
      footer={
        applied || fromJobBoard ? null : (
          <AscButton fullWidth onClick={() => onApply && onApply(jobId)}>
            Add to applied list
          </AscButton>
        )
      }
    >
      <div className={styles.bottomContent}>
        <div className={styles.leftContent}>
          <span className={styles.textContent}>
            <LocationIcon className={styles.icon} />
            <span className={styles.label}>
              {country} / {city}
            </span>
          </span>
          <span className={styles.textContent}>
            <CalendarIcon className={styles.icon} />
            {jobCategory && (
              <span className={styles.label}>
                {convertUnderlineToSpace(jobCategory)}
              </span>
            )}
          </span>
          {!isSmallVersion && (
            <span className={styles.textContent}>
              <DollarIcon className={styles.icon} />
              <span className={styles.label}>
                {formatSalaryRange(minSalaryRange, maxSalaryRange)}
              </span>
            </span>
          )}
        </div>
        {!isSmallVersion && (
          <span className={styles.datePosted}>
            Posted {dayjs(datePosted).fromNow()}
          </span>
        )}
      </div>
    </AscGenericCard>
  );
}
